import React, { Component } from 'react';
// import Collapsible from 'react-collapsible';
import AccordionHeader from '../components/CollapseHead';
// import AccordionContent from '../components/CollapseContent';

export default class extends Component {
  getHeader = data => {
    return  <AccordionHeader data={data}/>;
  };

  render() {
    return (
      <div>
        {this.props.elements.map((el, index) =>
          <div
            key={index}
            className="accordion-item">
            <AccordionHeader data={el}/>
          </div>
        )
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/personaTrecker/components/Base.js